import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import styled from 'styled-components';
const Inner = styled.div `
  max-width: 1920px;
  margin: auto;

  display: grid;
  grid-template-columns: 1fr;
  padding: 0px;

  @media ${from(Device.Mobile)} {
    grid-template-columns: 1fr 1fr;
  }

  @media ${from(Device.Tablet)} {
    grid-template-columns: repeat(3, 1fr);
  }

  @media ${from(Device.TabletLarge)} {
    display: flex;
    padding: 0px 48px;
  }

  @media ${until(Device.TabletLarge)} {
    flex-wrap: wrap;
  }
`;
const Container = styled.ul `
  background-color: ${brand.secondary.paleBlue};
  @media ${from(Device.TabletLarge)} {
    background-color: ${brand.secondary.lightBlue};
  }

  position: sticky;
  top: var(--headerHeight);
  z-index: 100;
`;
const Item = styled.li `
  font-size: ${fluid(16, 24, Device.Mobile, Device.TabletLarge)};
  line-height: 26px;
  position: relative;
  display: flex;

  @media ${until(Device.TabletLarge)} {
    border: 2px solid ${brand.primary.white};
  }

  @media ${from(Device.TabletLarge)} {
    &::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 2px;
      left: 0;
      top: 100%;
      background-color: ${brand.primary.darkBlue};

      opacity: 0;
      transform: translateY(25px);

      ${transition('opacity, transform', '0.25s', 'ease-in-out')}
    }

    &[data-active='true'] {
      &::after {
        opacity: 1;
        transform: translateY(0);
      }
    }
  }

  @media ${until(Device.TabletLarge)} {
    background-color: ${brand.secondary.paleBlue};
    &[data-active='true'] {
      background-color: ${brand.secondary.activeBlue};
    }

    ${transition('background-color', '0.25s', 'ease-in-out')}
  }

  a {
    text-decoration: none;
    color: ${brand.primary.darkBlue};
    ${fonts.ubuntu.regular};
    width: 100%;
    height: 100%;
    // prettier-ignore
    padding: ${fluid(8, 20, Device.Mobile, Device.TabletLarge)} ${fluid(15, 20, Device.Mobile, Device.TabletLarge)};

    @media ${until(Device.TabletLarge)} {
      text-align: center;
    }
  }
`;
export const InPageAnchorNavigationStyles = {
    Container,
    Item,
    Inner,
};
